import { createI18n } from 'vue-i18n'
import { DEFAULT_LOCALE, FALLBACK_LOCALE, readStoredLocale } from '@/constants/locale'

import zhCNCommon from './zh-CN/common'
import zhCNNav from './zh-CN/nav'
import zhCNLayout from './zh-CN/layout'
import zhCNConference from './zh-CN/conference'
import zhCNRoute from './zh-CN/route'
import zhCNMicrosite from './zh-CN/microsite'
import zhCNRegistration from './zh-CN/registration'
import zhCNParticipant from './zh-CN/participant'
import zhCNForbidden from './zh-CN/forbidden'
import zhCNMemberPlan from './zh-CN/memberPlan'
import zhCNMemberHub from './zh-CN/memberHub'
import zhCNRechargePackages from './zh-CN/rechargePackages'

import enCommon from './en/common'
import enNav from './en/nav'
import enLayout from './en/layout'
import enConference from './en/conference'
import enRoute from './en/route'
import enMicrosite from './en/microsite'
import enRegistration from './en/registration'
import enParticipant from './en/participant'
import enForbidden from './en/forbidden'
import enMemberPlan from './en/memberPlan'
import enMemberHub from './en/memberHub'
import enRechargePackages from './en/rechargePackages'

const zhCNMessages = {
  common: zhCNCommon,
  nav: zhCNNav,
  layout: zhCNLayout,
  conference: zhCNConference,
  route: zhCNRoute,
  microsite: zhCNMicrosite,
  registration: zhCNRegistration,
  participant: zhCNParticipant,
  forbidden: zhCNForbidden,
  memberPlan: zhCNMemberPlan,
  memberHub: zhCNMemberHub,
  rechargePackages: zhCNRechargePackages
}

const enMessages = {
  common: enCommon,
  nav: enNav,
  layout: enLayout,
  conference: enConference,
  route: enRoute,
  microsite: enMicrosite,
  registration: enRegistration,
  participant: enParticipant,
  forbidden: enForbidden,
  memberPlan: enMemberPlan,
  memberHub: enMemberHub,
  rechargePackages: enRechargePackages
}

const messages = {
  'zh-CN': zhCNMessages,
  en: enMessages
}

const i18n = createI18n({
  legacy: false,
  locale: readStoredLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages
})

export default i18n

/** Element Plus 语言包映射 */
export const elementPlusLocaleMap = {
  'zh-CN': () => import('element-plus/es/locale/lang/zh-cn'),
  en: () => import('element-plus/es/locale/lang/en')
}

export async function loadElementPlusLocale (locale) {
  const loader = elementPlusLocaleMap[locale] || elementPlusLocaleMap[DEFAULT_LOCALE]
  const mod = await loader()
  return mod.default
}
